import { Strategy } from 'utility-ts-strategy';
import { ISwapResultMessage, ISwapType } from '../../interfaces/scheduler_interfaces';

export let SwapErrorStrategy = new Strategy<ISwapResultMessage>({
  same_section: {
    text: 'The same section cannot be selected for swap'
  }
});

export let SwapTypeStrategy = new Strategy<ISwapType>({
  from: 'Selected for swap',
  to: 'New time selected'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/strategies/swap_strategy.ts